<template lang="pug">
	.sfc-button(:class="{'loading': loading, 'with-back-arrow': backArrow && text && text != '', 'with-continue-arrow': continueArrow && text && text != '', 'blue-button': blue, 'yellow-button': yellow, 'red-button': red, 'plus': plusIcon && text && text != '', 'empty': text == '' || !text, 'white-label-button': isWhiteLabel}" @click="$emit('click', $event)" role="button" tabindex="0" @keyup.prevent="handleKeyPress")
		.content(v-if="!loading")
			.arrow.arrow-left(v-if="backArrow")
			.button-text(v-if="text != null & text != '' && !link") {{text}}
			a.button-text(ref="sfcButtonLink" v-if="text != null & text != '' && link" :href="href" :target="target" tabindex="-1") {{text}}
			.arrow.arrow-right(v-if="continueArrow")
			.plus(v-if="plusIcon")
		spinner.spinner(size="20" v-if="loading")

</template>

<style lang="stylus" scoped>
@import '~assets/css/variables.styl'

.spinner
	vertical-align: top
	display: inline-block
	margin-top: -1px

.sfc-button
	position: relative
	cursor: pointer
	font-weight: body-font-weight-strong
	vertical-align: top
	padding: 10px 25px
	border-radius(4px)
	box-shadow(0 2px 6px 0 rgba(101,116,134,.075))
	border: 1px solid sfc-pale-blue-silver
	display: inline-block
	font-size: body-font-size
	max-height 42px

	@media(max-width: 575px)
		font-size: body-font-size
		max-height none
		padding: 16px 34px

	.content
		line-height: body-font-line-height-sm

	.arrow
		width: 0
		height: 0
		position: absolute
		border-bottom: 5px solid transparent
		border-top: 5px solid transparent
		top: 15px
		@media(max-width: 575px)
			top: 22px

	.arrow-left
		border-right: 6px solid body-font-color
		left: 16px
		@media(max-width: 575px)
			left: 24px

	.arrow-right
		border-left: 6px solid body-font-color
		right: 16px
		@media(max-width: 575px)
			right: 24px

	.plus
		&:after
		&:before
			position: absolute
			left: 15px
			top: 8px
			content: ''
			height: 20px
			width: 3px
			background-color: #fff
		&:before
			transform: rotate(90deg)

	.button-text
		display: inline-block
		line-height: body-font-line-height-sm


	&.blue-button
		background-color: sfc-royal-blue-bright
		border-color: sfc-royal-blue-dark
		.arrow-left
			border-right: 6px solid #fff

		.arrow-right
			border-left: 6px solid #fff

		.button-text
			color: #fff
			text-decoration: none

	&.white-label-button
		background-color: prudential-blue
		border-color: prudential-blue
		max-width 100%
		width 310px
		text-align center
		font-weight normal
		@media(max-width: 767px)
			width 100%
		.arrow-left
			border-right: 6px solid #fff

		.arrow-right
			border-left: 6px solid #fff

		.button-text
			color: #fff
			text-decoration: none
		&:focus
			opacity: 0.8
			prudential-box-shadow()

	&.yellow-button
		background-color: sfc-yellow
		border-color: sfc-yellow-dark
		color: #fff
		.arrow-left
			border-right: 6px solid #fff

		.arrow-right
			border-left: 6px solid #fff

		.button-text
			color: #fff
			text-decoration: none

	&.red-button
		border-color: #D0021B !important
		background-color: #F05B33 !important
		color: #fff
		.arrow-left
			border-right: 6px solid #fff

		.arrow-right
			border-left: 6px solid #fff

		.button-text
			color: #fff
			text-decoration: none

	&.with-back-arrow
		.button-text
			margin-left: 10px

	&.with-continue-arrow
		.button-text
			margin-right: 10px

	// &.plus
	// 	padding: 20px

	&.empty
		padding: 20px
		@media(max-width: 575px)
			padding: 26px

	&.loading
		line-height: body-font-line-height-sm
</style>

<script>
	import Spinner from 'vue-simple-spinner/src/components/Spinner.vue'
	export default {
		data() {
			return {

			}
		},
		components:{
			Spinner
		},
		props: {
			text: {
				default: null
			},
			backArrow: {
				default: false
			},
			continueArrow: {
				default: false
			},
			blue: {
				default: false
			},
			yellow: {
				default: false
			},
			red: {
				default: false
			},
			loading: {
				default: false
			},
			plusIcon: {
				default: false
			},
			link: {
				default: false
			},
			href: {
				default: ""
			},
			target: {
				default: "_self"
			},
			isWhiteLabel: {
				default: false
			}
		},

		methods: {
			handleKeyPress(key){
				if(this.$props.isWhiteLabel) {
					if (key.keyCode == 13 || key.keyCode === 32) {
						this.$emit("click")
						if (this.$props.link) {
							this.$refs.sfcButtonLink.click()
						}
					}
				}
			}

		}
	}
</script>
